import React from "react";
import { useState, useEffect, useRef, useMemo } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getDistrictList, getBlockList, getGpList, getTotalAvailableFund } from "../../Service/TotalAvailableFund";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const TotalAvailableFund = () => {
  const getCurrentDate = () => new Date().toISOString().split("T")[0];
  // State for From Date, To Date, and Input Box
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState(getCurrentDate());
  const [realAccList, setRealAccList] = useState();
  const [bank, setBank] = useState();
  const [data, setData] = useState();
  const jsonString = sessionStorage.getItem("SAHAJ_SARAL_USER");
  const userData = JSON.parse(jsonString);
  const [totalFundDetails, setTotalFundDetails] = useState([]);
  const [district, setDistrict] = useState();
  const [block, setBlock] = useState();
  const [gp, setGp] = useState();
  const [getDistrictDataList, setDistrictDataList] = useState([]);
  const [getBlockDataList, setBlockDataList] = useState([]);
  const [getGpDataList, setGpDataList] = useState([]);
  const [reportFor, setReportFor] = useState();

  useEffect(() => {
    const jsonString = sessionStorage.getItem("SAHAJ_SARAL_USER");
    const data = JSON.parse(jsonString);

    getDistrictList().then(function (result) {
      const response = result?.data;
      console.log(response, "resresres")
      setDistrictDataList(response);
      // setDistrict(data?.USER_LEVEL == "DIST" || data?.USER_LEVEL == "BLOCK" || data?.USER_LEVEL == "GP" ? data?.DIST_LGD : 0)
    });
  }, []);



  let DistrictListDropDown = <option>Loading...</option>;
  if (getDistrictDataList && getDistrictDataList.length > 0) {
    DistrictListDropDown = getDistrictDataList.map((distRow, index) => (
      <option value={distRow.DIST_LGD}>{distRow.DIST_NAME}</option>
    ));
  }

  console.log(DistrictListDropDown, "DistrictListDropDown")


  const onDistrict = (e) => {
    setDistrict(e.target.value)
    setBlock('')
    setGp('')
    getBlockList(e.target.value).then(function (result) {
      const response = result?.data;
      console.log(response, "resresres")
      setBlockDataList(response);
    });
  }
  let BlockListDropDown = <option>Loading...</option>;
  if (getBlockDataList && getBlockDataList.length > 0) {
    BlockListDropDown = getBlockDataList.map((blRow, index) => (
      <option value={blRow.BLOCK_LGD}>{blRow.BLOCK_NAME}</option>
    ));
  }

  const onBlock = (e) => {
    setBlock(e.target.value)
    setGp('')

    getGpList(e.target.value).then(function (result) {
      const response = result?.data;
      console.log(response, "resresres")
      setGpDataList(response);
    });
  }
  let GpListDropDown = <option>Loading...</option>;
  if (getGpDataList && getGpDataList.length > 0) {
    GpListDropDown = getGpDataList.map((gpRow, index) => (
      <option value={gpRow.GP_LGD}>{gpRow.GP_NAME}</option>
    ));
  }

  const onGp = (e) => {
    setGp(e.target.value)
  }


  const onBank = (e) => {
    setBank(e.target.value);
  }

  const onSearch = () => {
    if (!reportFor) {
      toast.error("Please select Report For option");
    } else {
      getTotalAvailableFund(district ? district : 0, block ? block : 0, gp ? gp : 0, reportFor).then((response) => {
        if (response.status === 200) {
          { response?.data?.statusMsg === "Success" ? toast.success("Data Fetched Successfully") : toast.error(response?.data?.statusMsg) }
          setTotalFundDetails(response.data);
        } else {
          toast.error("Failed to fetch data");
        }
      });

    }
  }

  const onReportFor = (e) => {
    setReportFor(e.target.value);
    setTotalFundDetails([]);
  }

  const exportToExcel = () => {
    const worksheetData = totalFundDetails?.dtls?.map((item, index) => ({
      "SL No.": index + 1,
      "District": item.priName,
      "Balance at Treasury": item.tryBalance,
      "Balance at Bank": item.bankBalance,
      "Cash in Hand": item.cashBalance,
      "Total": item.totalBalance,
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Total Fund Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "Total_Available_Fund_Report.xlsx");
  };

  console.log(totalFundDetails, "totalFundDetails")

  return (

    <div>
      <ToastContainer />
      <div className="bg-white rounded-lg p-2 flex flex-col flex-grow" style={{ marginTop: "-40px" }}>
        <legend className="text-lg font-semibold text-cyan-700">
          Total Available Fund As on {new Date().toLocaleString()}
        </legend>
        {/* From Date */}
        <div className=" flex flex-col space-y-2 py-1">
          <div className="flex flex-col w-full mb-4 space-y-2">
            <div className="flex items-center ">
              <div className="w-1/4">
                <label
                  htmlFor="receipt_name"
                  className="block text-sm font-medium text-gray-700"
                >
                  District
                </label>
                <select
                  id="receipt_name"
                  name="receipt_name"
                  autoComplete="off"
                  className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                  value={district}
                  onChange={onDistrict}
                // disabled={userData?.USER_LEVEL == "DIST" || userData?.USER_LEVEL == "BLOCK" || userData?.USER_LEVEL == "GP" ? true : false}

                >

                  <option value="" selected >
                    Select District
                  </option>

                  {DistrictListDropDown}

                </select>
              </div>

              <div className="w-1/4 px-2">
                <label
                  htmlFor="department_name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Block
                </label>
                <select
                  id="department_name"
                  name="department_name"
                  autoComplete="off"
                  className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                  onChange={onBlock}
                  value={block}
                // disabled={userData?.USER_LEVEL == "BLOCK" || userData?.USER_LEVEL == "GP" ? true : false}
                >

                  <option value="" selected >
                    Select Block
                  </option>
                  {BlockListDropDown}
                </select>
              </div>

              <div className="w-1/4 px-2">
                <label
                  htmlFor="scheme_name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Gram Panchayat
                </label>
                <select
                  id="scheme_name"
                  name="scheme_name"
                  autoComplete="off"
                  className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                  onChange={onGp}
                  value={gp}
                // disabled={userData?.USER_LEVEL == "GP" ? true : false}
                >

                  <option value="" selected >
                    Select Gram Panchayat
                  </option>
                  {GpListDropDown}
                </select>
              </div>

              <div className="w-1/4 px-2">
                <label
                  htmlFor="scheme_name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Report For <span className="text-red-500">*</span>
                </label>
                <select
                  id="scheme_name"
                  name="scheme_name"
                  autoComplete="off"
                  className="text-sm block w-full p-1 h-9 border border-gray-300 rounded-md"
                  onChange={onReportFor}

                >

                  <option value="" selected >
                    Select Report For
                  </option>
                  <option value="1" >
                    ZP
                  </option>
                  <option value="2" >
                    PS
                  </option>
                  <option value="3" >
                    GP
                  </option>

                </select>
              </div>

              {/* Generate Button */}
              <div className="w-1/6">
                <button
                  type="button"
                  className="btn-submit h-9 px-2 mt-5 shadow-sm text-white hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  onClick={onSearch}
                >
                  Search
                </button>
              </div>
            </div>


          </div>
          {totalFundDetails?.length === 0 ? (
            <div
              className="flex items-center justify-center bg-gray-200"
              style={{ marginTop: "10px" }}
            >
              <div className="text-center">
                <h1 className="text-xl font-semibold text-black-800">
                  No Data Found
                </h1>
              </div>
            </div>
          ) : (
            <div className="overflow-x-auto p-4">
              {/* Download Button & Heading */}
              <div className="flex justify-between items-center mb-2">
                <button
                  onClick={exportToExcel}
                  className="bg-green-600 text-white px-2 py-2 rounded hover:bg-green-700 transition"
                >
                  Download Excel
                </button>
                <h2 className="text-lg font-semibold text-gray-800 text-center animate-blink flex-1">
                  {reportFor === "1"
                    ? "Zilla Parishad"
                    : reportFor === "2"
                      ? "Panchayat Samiti"
                      : "Gram Panchayat"}{" "}
                  wise Total Available Fund - 2025-2026
                </h2>
              </div>

              <div className="border rounded overflow-hidden">
                <div className="max-h-[500px] overflow-y-auto">
                  <table className="min-w-full divide-y divide-gray-200 border text-sm">
                    <thead className="bg-cyan-600 text-white sticky top-0 z-10">
                      <tr>
                        <th className="px-4 py-2 text-left">SL No.</th>
                        <th className="px-4 py-2 text-left">District</th>
                        <th className="px-4 py-2 text-right">Balance at Treasury</th>
                        <th className="px-4 py-2 text-right">Balance at Bank</th>
                        <th className="px-4 py-2 text-right">Cash in Hand</th>
                        <th className="px-4 py-2 text-right">Total</th>
                      </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-100 bg-white">
                      {totalFundDetails?.dtls?.map((item, index) => (
                        <tr
                          key={index}
                          className={
                            item.totalBalance !== "0.00"
                              ? "bg-white"
                              : "bg-gray-50 text-gray-400"
                          }
                        >
                          <td className="px-4 py-2">{index + 1}</td>
                          <td className="px-4 py-2">{item.priName}</td>
                          <td className="px-4 py-2 text-right">{item.tryBalance}</td>
                          <td className="px-4 py-2 text-right">{item.bankBalance}</td>
                          <td className="px-4 py-2 text-right">{item.cashBalance}</td>
                          <td className="px-4 py-2 text-right font-semibold">{item.totalBalance}</td>
                        </tr>
                      ))}
                    </tbody>

                    <tfoot className="bg-gray-400 font-semibold text-black sticky bottom-0">
                      <tr>
                        <td className="px-4 py-2 text-left"></td>
                        <td className="px-4 py-2 text-left">Grand Total:</td>
                        <td className="px-4 py-2 text-right">
                          {totalFundDetails?.dtls
                            ?.reduce(
                              (sum, item) => sum + parseFloat(item.tryBalance || 0),
                              0
                            )
                            .toFixed(2)}
                        </td>
                        <td className="px-4 py-2 text-right">
                          {totalFundDetails?.dtls
                            ?.reduce(
                              (sum, item) => sum + parseFloat(item.bankBalance || 0),
                              0
                            )
                            .toFixed(2)}
                        </td>
                        <td className="px-4 py-2 text-right">
                          {totalFundDetails?.dtls
                            ?.reduce(
                              (sum, item) => sum + parseFloat(item.cashBalance || 0),
                              0
                            )
                            .toFixed(2)}
                        </td>
                        <td className="px-4 py-2 text-right">
                          {totalFundDetails?.dtls
                            ?.reduce(
                              (sum, item) => sum + parseFloat(item.totalBalance || 0),
                              0
                            )
                            .toFixed(2)}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          )}




        </div>
      </div>
    </div>

  );
};

export default TotalAvailableFund;
